var map = {
	"./add-black.svg": "2f3a",
	"./apps-black.svg": "f299",
	"./file-black.svg": "614d",
	"./game-black.svg": "3567",
	"./repair-black.svg": "2e1d",
	"./search-black.svg": "2394",
	"./sort-black.svg": "94c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df55";